import React from "react";
import { createGlobalStyle } from "styled-components";
import { useSelector } from "react-redux";
import { getMerchantConfig } from "features/config/configSlice";

const V2GlobalStyle = createGlobalStyle`
  body:has(.rms-v2-shell) {
    --rms-v2-font-family: ${(props) => props.fontStack || "Inter, sans-serif"};
    --rms-v2-primary: ${(props) => props.primaryColor || "#0b5ee8"};
    --rms-v2-primary-soft: ${(props) =>
      /^#[0-9A-Fa-f]{6}$/.test(props.primaryColor || "")
        ? `${props.primaryColor}1F`
        : "rgba(11, 94, 232, 0.12)"};
    --rms-v2-primary-faint: ${(props) =>
      /^#[0-9A-Fa-f]{6}$/.test(props.primaryColor || "")
        ? `${props.primaryColor}12`
        : "rgba(11, 94, 232, 0.07)"};
    --rms-v2-text-title: #2C333A;
    --rms-v2-text-body: #3b444d;
    --rms-v2-text-muted: #586068;
    --rms-v2-page-bg: #f5f5f5;
    --rms-v2-section-bg: #f3f6fb;
    --rms-v2-surface: #fff;
    --rms-v2-surface-muted: #f4f7fb;
    --rms-v2-border: #d1d7df;
    --rms-v2-border-soft: #e4eaf2;
    --rms-v2-success: #16ac37;
    --rms-v2-success-soft: #def8e4;
    --rms-v2-danger: #b21411;
    --rms-v2-danger-soft: #fff1f1;
    --rms-v2-warning: #963d1f;
    --rms-v2-warning-soft: #fff7de;
    --rms-v2-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: #edf1f8;
    font-family: var(--rms-v2-font-family) !important;
  }

  html:has(.rms-v2-shell) {
    background: #edf1f8;
  }

  .rms-v2-shell {
    --rms-v2-font-family: ${(props) => props.fontStack || "Inter, sans-serif"};
    --rms-v2-primary: ${(props) => props.primaryColor || "#0b5ee8"};
    --rms-v2-primary-soft: ${(props) =>
      /^#[0-9A-Fa-f]{6}$/.test(props.primaryColor || "")
        ? `${props.primaryColor}1F`
        : "rgba(11, 94, 232, 0.12)"};
    --rms-v2-primary-faint: ${(props) =>
      /^#[0-9A-Fa-f]{6}$/.test(props.primaryColor || "")
        ? `${props.primaryColor}12`
        : "rgba(11, 94, 232, 0.07)"};
    --rms-v2-text-title: #2C333A;
    --rms-v2-text-body: #3b444d;
    --rms-v2-text-muted: #586068;
    --rms-v2-page-bg: #f5f5f5;
    --rms-v2-section-bg: #f3f6fb;
    --rms-v2-surface: #fff;
    --rms-v2-surface-muted: #f4f7fb;
    --rms-v2-border: #dce4ef;
    --rms-v2-border-soft: #e4eaf2;
    --rms-v2-success: #16ac37;
    --rms-v2-success-soft: #def8e4;
    --rms-v2-danger: #b21411;
    --rms-v2-danger-soft: #fff1f1;
    --rms-v2-warning: #963d1f;
    --rms-v2-warning-soft: #fff7de;
    --rms-v2-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    min-height: 100vh;
    background: #edf1f8;
    color: var(--rms-v2-text-title);
    display: flex;
    justify-content: center;
    font-family: var(--rms-v2-font-family) !important;
  }

  .rms-v2-shell *,
  .rms-v2-shell input,
  .rms-v2-shell textarea,
  .rms-v2-shell select,
  .rms-v2-shell button,
  .rms-v2-shell .MuiTypography-root,
  .rms-v2-shell .MuiInputBase-root,
  .rms-v2-shell .MuiInputBase-input,
  .rms-v2-shell .MuiButton-root,
  .rms-v2-shell .MuiMenuItem-root,
  body:has(.rms-v2-shell) .MuiPaper-root,
  body:has(.rms-v2-shell) .MuiPaper-root *,
  body:has(.rms-v2-shell) .MuiPopover-root,
  body:has(.rms-v2-shell) .MuiPopover-root *,
  body:has(.rms-v2-shell) .MuiModal-root,
  body:has(.rms-v2-shell) .MuiModal-root *,
  body:has(.rms-v2-shell) .rms-footer-wrapper,
  body:has(.rms-v2-shell) .rms-footer-wrapper *,
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"],
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"] * {
    font-family: var(--rms-v2-font-family) !important;
  }

  .rms-v2-shell button,
  .rms-v2-shell .MuiButton-root,
  body:has(.rms-v2-shell) .MuiModal-root button,
  body:has(.rms-v2-shell) .MuiModal-root .MuiButton-root,
  body:has(.rms-v2-shell) .MuiPopover-root button,
  body:has(.rms-v2-shell) .MuiPopover-root .MuiButton-root {
    text-transform: none !important;
  }

  .rms-v2-shell > *:not(style):not(.v2-header-wrapper):not(.rms-footer-wrapper) {
    width: 100%;
    max-width: 500px;
    min-height: 100vh;
    border-left: 1px solid var(--rms-v2-border-soft);
    border-right: 1px solid var(--rms-v2-border-soft);
    box-shadow: 0 22px 60px rgba(29, 42, 64, 0.1);
    box-sizing: border-box;
  }

  .rms-v2-shell > .v2-page-header {
    border-left: 1px solid var(--rms-v2-border-soft);
    border-right: 1px solid var(--rms-v2-border-soft);
    box-shadow: none;
  }

  body:has(.replacement-search.is-stuck) .rms-v2-shell > *:not(style):not(.v2-header-wrapper):not(.rms-footer-wrapper),
  body:has(.search-shell.is-stuck) .rms-v2-shell > *:not(style):not(.v2-header-wrapper):not(.rms-footer-wrapper) {
    box-shadow: none;
  }

  .rms-v2-shell .MuiButton-contained {
    background: var(--rms-v2-primary) !important;
    color: var(--rms-v2-surface) !important;
    -webkit-text-fill-color: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-sizing: border-box;
    height: 40px;
    min-height: 40px;
    box-shadow: 0 14px 28px var(--rms-v2-primary-soft);
    text-transform: none;
    font-weight: 800;
  }

  .rms-v2-shell .MuiButton-outlined {
    border-color: var(--rms-v2-primary) !important;
    color: var(--rms-v2-primary) !important;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
    text-transform: none;
    font-weight: 800;
  }

  .rms-v2-shell input,
  .rms-v2-shell textarea,
  .rms-v2-shell .MuiOutlinedInput-root,
  .rms-v2-shell .MuiInputBase-root {
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
  }

  .rms-v2-shell img,
  .rms-v2-shell .lazy-load-image-background {
    border-radius: var(--rms-v2-radius);
  }

  .rms-v2-shell [class*="StyledHeaderWrapper"] img,
  .rms-v2-shell .v2-page-header img,
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"] img {
    border-radius: 0 !important;
  }

  .rms-v2-shell .MuiAccordion-root,
  .rms-v2-shell .return-box,
  .rms-v2-shell .price-details,
  .rms-v2-shell .pickup-address-web,
  .rms-v2-shell .return-request > div,
  .rms-v2-shell .MuiPaper-root {
    border-radius: var(--rms-v2-radius) !important;
  }

  .rms-v2-shell .return-box,
  .rms-v2-shell .MuiAccordion-root {
    border: 1px solid var(--rms-v2-border) !important;
    box-shadow: 0 16px 36px rgba(30, 45, 70, 0.06) !important;
    overflow: hidden;
  }

  body:has(.rms-v2-shell) .rms-footer-wrapper,
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"] {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: 100%;
    max-width: 500px;
    padding: 5px 0;
    box-sizing: border-box;
    background: var(--rms-v2-surface) !important;
    justify-content: center;
    border-left: 1px solid var(--rms-v2-border-soft);
    border-right: 1px solid var(--rms-v2-border-soft);
    box-shadow: 0 22px 60px rgba(29, 42, 64, 0.1);
  }

  body:has(.rms-v2-shell) .rms-footer-wrapper > div,
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"] > div {
    width: 100% !important;
    justify-content: space-between !important;
    padding: 0 14px !important;
    box-sizing: border-box !important;
  }

  body:has(.rms-v2-shell) .rms-footer-wrapper .help,
  body:has(.rms-v2-shell) [class*="StyledFooterWrapper"] .help {
    display: block !important;
  }

  .rms-v2-shell .v2-header-wrapper {
    width: 100%;
    max-width: 500px;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    background: var(--rms-v2-surface);
    border-bottom: 1px solid var(--rms-v2-border-soft);
    border-left: 1px solid var(--rms-v2-border-soft);
    border-right: 1px solid var(--rms-v2-border-soft);
    box-shadow: none;
  }

  `;

function V2RouteShell({ children }) {
  const merchantConfig = useSelector(getMerchantConfig);
  const fontFamily = merchantConfig?.google_font_family || "Inter";
  const fontStack = [fontFamily, "Inter", "sans-serif"].join(", ");

  return (
    <div className="rms-v2-shell tw-min-h-screen">
      <V2GlobalStyle
        primaryColor={merchantConfig?.primary_theme_color || "#0b5ee8"}
        rounded={merchantConfig?.use_rounded_edge_buttons}
        fontStack={fontStack}
      />
      {children}
    </div>
  );
}

export default V2RouteShell;
